import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';
import Avatar from '../Avatar';

const UserPreview = ({ title, subtitle, info, initials, avatar, onClick, className, ...props }) => {
  const cn = useClassNames(
    () => ['flex', 'flex-col', 'p-4', 'cursor-pointer', 'flex-wrap', 'focus:outline-none'],
    [className],
  );

  return (
    <button type="button" className={cn} onClick={onClick} {...props}>
      <div className="flex items-center w-72 mb-4">
        <Avatar className="flex-shrink-0" alt={title} src={avatar} initials={initials} />
        <div className="ml-2 text-left min-w-0 overflow-hidden">
          <div className="font-semibold text-lg truncate">{title}</div>
          <div className="text-slate-500 truncate text-sm">{subtitle}</div>
          <div className="text-slate-500 truncate text-sm">{info}</div>
        </div>
      </div>
      <div className="border-b px-2 w-full h-1" />
    </button>
  );
};

UserPreview.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  info: PropTypes.string,
  initials: PropTypes.string,
  avatar: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

UserPreview.defaultProps = {
  onClick: () => {},
};

export default UserPreview;
